module.exports = function() {
  return new Worker(__webpack_public_path__ + "08c70ab6ab4eab37ffae.worker.js");
};